import React from "react";
import moment from "moment";
import { Popup } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/pro-solid-svg-icons";
import "moment-duration-format";

import { ThumbToggle, Pin } from "../../../../components";
import { renderReadyStatus } from "../../../Appointments/common";

import "./InterventionQuickView.scss";

const InterventionQuickView = ({ appointment, popupTrigger }) => {
  if (!appointment.interventions) return popupTrigger;

  const content = appointment.interventions.map(i => (
    <div className="InterventionQuickView-interventions-container" key={i.id}>
      <div className="title-description-container">
        <div className="title">{i.title}</div>
      </div>

      <div className="special-indicators-container">
        {i.labor_minutes ? (
          <span className="labor-minutes">
            <FontAwesomeIcon icon={faClock} />
            {moment.duration(i.labor_minutes, "minutes").format("HH:mm", { trim: false })}
          </span>
        ) : null}
        <Pin disabled appointment={appointment} intervention={i} pinLog={i.pin_history || []} />
        <ThumbToggle status={i.customer_ok} onClick={null} />
        <span className="AnswerReadyStatus">{i.customer_ok && renderReadyStatus(i.mechanic_fixed)}</span>
      </div>
    </div>
  ));

  return (
    <Popup
      trigger={popupTrigger}
      children={<div className="InterventionQuickViewContent">{content}</div>}
      hoverable
      style={{ padding: "0 5px" }}
      popperModifiers={{
        preventOverflow: {
          boundariesElement: "offsetParent",
        },
        flip: {
          flipVariationsByContent: true,
        },
      }}
    />
  );
};

export default InterventionQuickView;
